import {observable,action,runInAction} from 'mobx'
import {json} from "../../../../utils/ajax";
import {objToValueObj, setStore, ValueObjToObj} from '../../../../utils/Utils'

class EPCChapterMainStore{
    @observable loading //页面加载
    @observable list //初始化页面数据
    @observable isShowModal //是否显示modal
    @observable modalType //当前显示的modal的类型（新增/修改）
    @observable editData //表单的值
    @observable editRecord //行数据
    @observable pageSize//每页条数
    @observable current//当前页数
    @observable addEditModal //新增模态框
    @observable addEditTitle   //模态框名字

    constructor(){
        this.loading = false
        this.list = []
        this.isShowModal = false
        this.modalType = -1
        this.editData = {
            name:{},
            code:{},
            description:{}
        }
        this.editRecord = {}
        this.pageSize = 20
        this.current = 1
        this.addEditModal = false
        this.addEditTitle = ''
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }


    /**
     * 初始化页面
     * @returns {Promise<void>}
     */
    @action
    initPage = async ()=>{
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/queryListByTree`)
        runInAction(()=>{
            this.loading = false
            this.list = Array.isArray(res)?res:[]
        })
    }


    /**
     * 点击新增模态框
     * @param record
     * @param type
     */
    @action
    openModal = (record,type)=>{
        this.isShowModal = true
        this.editData = {
            name:{},
            code:{},
            description:{}
        }
        this.editRecord = record
        this.modalType = type
        if(type===2){
            this.editData = objToValueObj(record)
        }
    }

    /**
     * 关闭模态框
     */
    @action
    closeModal = ()=>{
        this.addEditModal = false
    }

    /**
     * 从页面传到store的值
     * @param changedFields
     */
    @action
    onFieldsChange = (changedFields)=>{
        this.editData={...this.editData,...changedFields}
    }

    /***
     * 保存添加的数据
     * @returns {Promise<void>}
     */
    @action
    onSave = async ()=>{
        const data = ValueObjToObj(this.editData)
        let params = {...data}
        let res = ''
        switch (this.modalType) {
            case 0:{
                params.pid = this.editRecord.pid
                res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/addSameLevel`,params)
                break;
            }
            case 1:{
                params.pid = this.editRecord.id
                res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/addSubordinate`,params)
                break;
            }
            case 2:{
                res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/modifyById`,params)
                break;
            }
            case 3:{
                res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/chapterMain/addTopData`,params)
                break;
            }
            default:
                break
        }
        if(res.status === 0 ){
            // message.warning('操作失败')
            return
        }
        runInAction(()=>{
            this.isShowModal = false
        })
        this.initPage()
    }

    /**
     * 一页有多少条数据
     * @param pageSize
     */
    @action
    onShowSizeChange=(pageSize)=>{
        this.pageSize = pageSize
    }

    /**
     * 翻页
     * @param current
     */
    @action
    onCurrentChange=(current)=>{
        this.current = current
    }

}

export default new EPCChapterMainStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/basicDataOfAutomobile/EPCChapterMain/store.js